'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { ProductBadge } from './product-badge';
import { ProductStatusText } from '@eliadmin/core/src/components/product/product-status-text';
import { getContrastYIQ } from '@eliadmin/core/src/utils/style-utils';

export function ProductDetailBadges({ product }: { product: ProductDetailData }) {
  const selectedVariant = useVariantsStore(state => state.selectedVariant);

  const desiredObject =
    product?.variants && product.variants.length > 0 ? selectedVariant : product;

  const showAvailability = desiredObject?.availability && desiredObject?.availability.id !== 1;
  const hasSpecialProductStatus = product.status === 'ended' || product.status === 'arrival';

  return (
    <div className="flex items-start justify-start gap-2">
      {hasSpecialProductStatus ? (
        <ProductStatusText status={product.status} sizeClassName="text-xs" />
      ) : (
        showAvailability && (
          <ProductBadge
            text={product.availability?.name || ''}
            background={product.availability?.color || '#E0E0E0'}
            color={getContrastYIQ('#000000')}
          />
        )
      )}
      {product.tags?.map(tag => (
        <ProductBadge
          key={tag.name}
          text={tag.name}
          background={tag.color ?? '#000000'}
          color={getContrastYIQ(tag.color ?? '#000000')}
        />
      ))}
    </div>
  );
}
